module.exports = __webpack_public_path__ + "img/robotica.394187c5.png";